import { AutogenModelMappingVendor, AutogenRowMappingVendor } from "./autogen/AutogenModelMappingVendor";

export class ModelMappingVendor extends AutogenModelMappingVendor<RowMappingVendor> {
	constructor() {
		super(RowMappingVendor);
	}
}

export class RowMappingVendor extends AutogenRowMappingVendor {
}